<span [matTooltip]="warningTooltip" class="mat-mdc-button-wrapper">
  <button [type]="type"
          mat-raised-button
          color="primary"
          [disabled]="disabled || isLoading"
          [name]="nameAttr"
          (click)="emitOnClick($event)">
    <mat-icon *ngIf="warning">warning</mat-icon>
    <mat-spinner *ngIf="isLoading" class="spinner" diameter="18" color="accent"></mat-spinner>
    {{title}}
  </button>
</span>
